import { Path, Svg } from 'react-native-svg'

// eslint-disable-next-line no-relative-import-paths/no-relative-import-paths
import { createIcon } from '../factories/createIcon'

export const [Bank, AnimatedBank] = createIcon({
  name: 'Bank',
  getIcon: (props) => (
    <Svg viewBox="0 0 20 20" fill="none" {...props}>
      <Path
        d="M2.5 6.36549C2.5 6.06293 2.67292 5.78699 2.94519 5.65505L8.96698 2.73705C9.61922 2.42098 10.3803 2.42099 11.0325 2.73705L17.0543 5.65505C17.3266 5.78699 17.4995 6.06293 17.4995 6.36549V7.26185C17.4995 7.27251 17.4993 7.28312 17.4989 7.29368C17.4993 7.30381 17.4995 7.31399 17.4995 7.32423C17.4995 7.72565 17.1741 8.05106 16.7727 8.05106H16.7294L16.7101 8.0513H3.28945L3.27012 8.05106H3.22684C2.82542 8.05106 2.5 7.72565 2.5 7.32423C2.5 7.31399 2.50021 7.30381 2.50063 7.29368C2.50021 7.28312 2.5 7.27251 2.5 7.26185V6.36549Z"
        fill={'currentColor' ?? '#131313'}
      />
      <Path
        d="M4.03958 14.5926C3.60358 14.5926 3.25013 14.9461 3.25013 15.3821V16.7106C3.25013 17.1466 3.60358 17.5 4.03958 17.5H15.9602C16.3962 17.5 16.7497 17.1466 16.7497 16.7106V15.3821C16.7497 14.9461 16.3962 14.5926 15.9602 14.5926H4.03958Z"
        fill={'currentColor' ?? '#131313'}
      />
      <Path
        d="M6.13177 8.97352C5.69577 8.97352 5.34232 9.32697 5.34232 9.76297V12.9208C5.34232 13.3568 5.69577 13.7102 6.13177 13.7102H6.28966C6.72566 13.7102 7.0791 13.3568 7.0791 12.9208V9.76297C7.0791 9.32697 6.72566 8.97352 6.28966 8.97352H6.13177Z"
        fill={'currentColor' ?? '#131313'}
      />
      <Path
        d="M9.13151 9.76297C9.13151 9.32697 9.48496 8.97352 9.92096 8.97352H10.0788C10.5148 8.97352 10.8683 9.32697 10.8683 9.76297V12.9208C10.8683 13.3568 10.5148 13.7102 10.0788 13.7102H9.92096C9.48496 13.7102 9.13151 13.3568 9.13151 12.9208V9.76297Z"
        fill={'currentColor' ?? '#131313'}
      />
      <Path
        d="M13.7102 8.97352C13.2742 8.97352 12.9207 9.32697 12.9207 9.76297V12.9208C12.9207 13.3568 13.2742 13.7102 13.7102 13.7102H13.868C14.304 13.7102 14.6575 13.3568 14.6575 12.9208V9.76297C14.6575 9.32697 14.304 8.97352 13.868 8.97352H13.7102Z"
        fill={'currentColor' ?? '#131313'}
      />
    </Svg>
  ),
  defaultFill: '#131313',
})
